/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef, useState} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {getCSS, getCSSVariableValue} from '../../../assets/ts/_utils'
import {useIntl} from 'react-intl'

type Props = {
  className: string
  selectedData?: any
}

const ChartsWidget2: React.FC<Props> = ({className, selectedData}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const [selectedDate, setSelectedDate] = useState('yearData')
  // Dil
  const intl = useIntl()
  const t = (id: any, values = {}) => intl.formatMessage({id}, values)
  useEffect(() => {
    if (!chartRef.current) {
      return
    }

    const height = parseInt(getCSS(chartRef.current, 'height'))
    // setSelectedDate(selectedData.yearData)

    const chart = new ApexCharts(
      chartRef.current,
      getChartOptions(height, selectedDate, selectedData)
    )
    if (chart) {
      chart.render()
    }

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, selectedData, selectedDate])

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      {console.log(selectedDate)}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-3 mb-1'>{selectedData.name}</span>

          <span className='text-muted fw-bold fs-7'>
            {t('total')}:{' '}
            {selectedData.chart2[selectedDate].data.data.reduce(
              (total: any, num: any) => total + num,
              0
            )}{' '}
            mW
          </span>
        </h3>

        {/* begin::Toolbar */}
        <div className='card-toolbar' data-kt-buttons='true'>
          <div>
            <a
              className={`btn btn-sm btn-color-muted btn-active btn-active-primary ${
                selectedDate === 'yearData' && 'active'
              } px-4 me-1`}
              id='kt_charts_widget_3_year_btn'
              onClick={(e) => setSelectedDate('yearData')}
            >
              {t('yearly')}
            </a>
          </div>
          <div>
            <a
              className={`btn btn-sm btn-color-muted btn-active btn-active-primary  ${
                selectedDate === 'monthData' && 'active'
              } px-4 me-1`}
              id='kt_charts_widget_3_month_btn'
              onClick={(e) => setSelectedDate('monthData')}
            >
              {t('monthly')}
            </a>
          </div>
          <div>
            <a
              className={`btn btn-sm btn-color-muted btn-active btn-active-primary  ${
                selectedDate === 'weekData' && 'active'
              } px-4 me-1`}
              id='kt_charts_widget_3_week_btn'
              onClick={(e) => setSelectedDate('weekData')}
            >
              {t('weekly')}
            </a>
          </div>
        </div>
        {/* end::Toolbar */}
      </div>
      {/* end::Header */}

      {/* begin::Body */}
      <div className='card-body'>
        {/* begin::Chart */}
        <div ref={chartRef} id='kt_charts_widget_3_chart' style={{height: '350px'}}></div>
        {/* end::Chart */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {ChartsWidget2}

function getChartOptions(height: number, selectedDate: any, selectedData: any): ApexOptions {
  const labelColor = getCSSVariableValue('--bs-gray-500')
  const borderColor = getCSSVariableValue('--bs-gray-200')
  const baseColor = getCSSVariableValue('--bs-info')
  const lightColor = getCSSVariableValue('--bs-light-info')

  return {
    series: [selectedData.chart2[selectedDate].data],
    chart: {
      fontFamily: 'inherit',
      type: 'area',
      height: 350,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {},
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: 'solid',
      opacity: 1,
    },
    stroke: {
      curve: 'smooth',
      show: true,
      width: 3,
      colors: [baseColor],
    },
    xaxis: {
      categories: selectedData.chart2[selectedDate].categories,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
      crosshairs: {
        position: 'front',
        stroke: {
          color: baseColor,
          width: 1,
          dashArray: 3,
        },
      },
      tooltip: {
        enabled: true,
        formatter: undefined,
        offsetY: 0,
        style: {
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: function (val) {
          return val + ' mW'
        },
      },
    },
    colors: [lightColor],
    grid: {
      borderColor: borderColor,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    markers: {
      strokeColors: baseColor,
      strokeWidth: 3,
    },
  }
}
